import { render } from "./StationeryCreate.vue?vue&type=template&id=f975bf78&scoped=true"
import script from "./StationeryCreate.vue?vue&type=script&lang=js"
export * from "./StationeryCreate.vue?vue&type=script&lang=js"

import "./StationeryCreate.vue?vue&type=style&index=0&id=f975bf78&scoped=true&lang=css"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f975bf78"]])

export default __exports__